import React from 'react';
import { ProductReview } from 'types';
import StarRating from 'components/StarRating';

interface ReviewProps {
  review: ProductReview;
}

type Props = React.FC<React.HTMLProps<HTMLDivElement> & ReviewProps>;

const Review: Props = ({ className, children, review, ...props }) => {
  return (
    <div {...props} className={`space-y-16 bg-white p-32 sm:grid sm:grid-cols-12 sm:gap-32 sm:space-y-0 ${className ? className : ''}`}>
      <div className="col-span-3">
        <h4 className="text-h4"> {review.reviewer} </h4>

        <p>{new Date(review.createdAt).toDateString()}</p>
      </div>

      <p className="col-span-7 overflow-hidden overflow-ellipsis">{review.content}</p>

      <StarRating rating={review.score} className="col-span-2" />
    </div>
  );
};

export default Review;
